var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 0H1.6C0.715 0 0 0.715 0 1.6V38.4C0 39.285 0.715 40 1.6 40H38.4C39.285 40 40 39.285 40 38.4V1.6C40 0.715 39.285 0 38.4 0ZM11.865 34.085H5.93V14.995H11.865V34.085ZM8.9 12.385C8.21963 12.385 7.55454 12.1832 6.98884 11.8053C6.42313 11.4273 5.98222 10.89 5.72185 10.2614C5.46149 9.63285 5.39337 8.94118 5.5261 8.27389C5.65883 7.60659 5.98646 6.99365 6.46755 6.51255C6.94865 6.03146 7.56159 5.70383 8.22889 5.5711C8.89618 5.43837 9.58785 5.50649 10.2164 5.76685C10.845 6.02722 11.3823 6.46813 11.7603 7.03384C12.1382 7.59954 12.34 8.26463 12.34 8.945C12.335 10.845 10.795 12.385 8.9 12.385ZM34.085 34.085H28.155V24.8C28.155 22.585 28.115 19.74 25.07 19.74C21.985 19.74 21.51 22.15 21.51 24.64V34.085H15.585V14.995H21.275V17.605H21.355C22.145 16.105 24.08 14.52 26.97 14.52C32.98 14.52 34.085 18.475 34.085 23.615V34.085Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.458e0c6227a3cae4382d0802ce502a7f.svg";
export { ForwardRef as ReactComponent };